module.exports = "https://tutorchat.chegg.com/static/media/ic-close.9a83a706.svg";